/** V2-only: avoid writing legacy loanstates while on split-table loan pages. */

export const LOS_SKIP_LOANSTATES_SYNC = "losSkipLoanstatesSync"

export function setLosSkipLoanstatesSync(skip) {
    if (skip) {
        sessionStorage.setItem(LOS_SKIP_LOANSTATES_SYNC, "true")
        return
    }
    sessionStorage.removeItem(LOS_SKIP_LOANSTATES_SYNC)
}

export function shouldSkipLosLoanstatesSync() {
    return sessionStorage.getItem(LOS_SKIP_LOANSTATES_SYNC) === "true"
}
